import { render } from "./Main-Page.vue?vue&type=template&id=5c0e01ae"
import script from "./Main-Page.vue?vue&type=script&lang=js"
export * from "./Main-Page.vue?vue&type=script&lang=js"

import "./Main-Page.vue?vue&type=style&index=0&id=5c0e01ae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__